/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CeproDocsCancelPartialUpdateRequest = {} | null | undefined;
export type CeproDocsCancelPartialUpdateResponse = any;

export type CeproDocsCancelPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/cepro_docs/{id}/cancel/
 *
 * ```yaml
 * operationId: cepro_docs_cancel_partial_update
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const ceproDocsCancelPartialUpdateOperation = ({
  id,
  ...rest
}: CeproDocsCancelPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/cepro_docs/${id}/cancel/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/{id}/cancel/' };
  };

/**
 * PATCH /dmx-server/cepro_docs/{id}/cancel/
 *
 * ```yaml
 * operationId: cepro_docs_cancel_partial_update
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const ceproDocsCancelPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CeproDocsCancelPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = ceproDocsCancelPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
